import Vue from 'vue';
import App from './app.vue';
import { router } from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import VueSweetalert2 from 'vue-sweetalert2';
import VueHtmlToPaper from 'vue-html-to-paper';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import VueToast from 'vue-toast-notification';
import moment from 'moment';
import excel from 'vue-excel-export'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import 'vue-toast-notification/dist/theme-sugar.css';
import Maska from 'maska';
import { VueEditor } from 'vue2-quill-editor';
Vue.use(Maska);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-editor', VueEditor);
const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
};
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm');
  }
});
Vue.filter('formatOnlyDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  }
});
Vue.filter('formatOnlyHour', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm');
  }
});

Vue.filter('onlyFormatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  }
});
localize('ar');
library.add(faUserSecret);
Vue.use(VueSweetalert2);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VueHtmlToPaper, options);
Vue.use(VueToast, { position: 'top-right' });
Vue.use(excel);

import store from './store/index';
import vuetify from './plugins/vuetify';
Vue.config.productionTip = false;

import '@/assets/vendor/fontawesome-free/css/all.min.css'; /* injected */

import '@/assets/vendor/jquery/jquery.min.js'; /* injected */
import '@/assets/vendor/bootstrap/js/bootstrap.bundle.min.js'; /* injected */
import '@/assets/vendor/jquery-easing/jquery.easing.min.js'; /* injected */
import '@/assets/js/sb-admin-2.min.js'; /* injected */
import '@/assets/css/sb-admin-2.css'; /* injected */

import { appRouters, otherRouters } from './router/router';

if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue(
    'Abp.Localization.CultureName',
    language,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  );
}
Vue.config.productionTip = false;

//Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{

//Util.abp=Util.extend(true,Util.abp,data.data.result);
var token = Util.abp.auth.getToken();
Util.abp = Util.extend(true, Util.abp, token);
new Vue({
  render: (h) => h(App),
  router: router,
  store: store,
  data: {
    currentPageName: '',
  },
  async mounted() {
    this.currentPageName = this.$route.name as string;
    await this.$store.dispatch({
      type: 'session/init',
    });
    // if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
    // if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
    // SignalRAspNetCoreHelper.initSignalR();
    // }
    // }
    this.$store.commit('app/initCachepage');
    this.$store.commit('app/updateMenulist');
  },
  created() {
    let tagsList: Array<any> = [];
    appRouters.map((item) => {
      if (item.children.length <= 1) {
        tagsList.push(item.children[0]);
      } else {
        tagsList.push(...item.children);
      }
    });
    this.$store.commit('app/setTagsList', tagsList);
  },
  vuetify,
}).$mount('#app');
//})
